import React from 'react'
import { blogdata } from './blogsdata';
import { Link } from 'react-router-dom';

import { truncateDescription } from './utils';
const BlogCard = () => {
    const visibleBlogs =  blogdata.slice(0, 3);
  return (
    <main>
         <div className='grid xl:grid-cols-3 lg:grid-cols-2 grid-cols-1 place-items-center gap-x-4 gap-y-6 my-10'>
        {visibleBlogs.map((data,index) => (
           <Link  to={`/blogs/${encodeURIComponent(data.title)}`}>
            <div key={index} className='rounded-2xl p-4 max-w-[29em] grid place-items-center' data-aos="fade-up" data-aos-duration="1000">
                <div className='relative group'>
                <figure className='overflow-hidden w-84 h-60'>
                    <img src={data.img} alt="images" className='w-full h-full object-cover group-hover:brightness-50 group-hover:scale-125 duration-300 ease-in-out cursor-pointer ' />
                 </figure>
                 <p className='about-us-btn absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2  rounded-2xl px-4 py-1 bg-gray-800 bg-opacity-40  backdrop-filter backdrop-blur-sm hidden group-hover:block cursor-pointer'>Read more</p>
                </div>
                   <h2 className='text-2xl font-semibold pt-2'>{data.title}</h2>
                   <p className="text-gray-500 py-2">{truncateDescription(data.desc)}</p>
                   <div className='w-full flex justify-between text-gray-500'>
                    <p className='font-semibold'>{data.date}</p>
                    <p className='bg-clip-text text-transparent bg-gradient-to-r from-[#E10B7B] via-[#652D90 ] to-[#1C85C7]'>{data.type}</p>
                   </div>
                 </div>   
           </Link>
        ))}
      </div>
    </main>
  )
}

export default BlogCard